import { actions } from './transaction/actions'
import { getters } from './transaction/getters'
import { state } from './transaction/state'
import { mutations } from './transaction/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}